// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Legal-module__wrap--3DF75","menu":"Legal-module__menu--klENH","link":"Legal-module__link--1YTDu","copyright":"Legal-module__copyright--BaMW5"};